import * as React from 'react'
import { MoreButton } from '@sales-center/components'
import { ITenantUser } from '@user/store/users'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'

interface Props {
  user: ITenantUser
  handleEditClick: (userId: string) => void
  handleDeleteRequest: (userId: string) => void
  disableDeleteTooltip: (user: ITenantUser) => string | undefined
  handleUpdateFromPPRequest: (externalUserId: string) => void
}

export function ActionMenu(props: Props) {
  const {
    user,
    handleEditClick,
    handleDeleteRequest,
    disableDeleteTooltip,
    handleUpdateFromPPRequest,
  } = props

  const { emailAddress: currentUserEmail } = useSelector(selectCurrentUser)

  return (
    <>
      {(user.emailAddress != currentUserEmail || user.isSuperAdmin) && (
        <MoreButton
          dataTestId={`userActionsMoreBtn-${user.id}`}
          disabled={
            !user.isCoreProductEnabled && user.isActive && user.isSSOMappedUser
          }
          style={{ color: '#091B2A8F' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          options={[
            {
              label: 'Edit',
              disabled: user.isExternalUser && !user.isActive,
              onClick: () => handleEditClick(user.id),
            },
            {
              disabled:
                !!user.leadCount || !!user.oppCount || user.isSuperAdmin,
              label: 'Delete',
              onClick: () => handleDeleteRequest(user.id),
              tooltipText: disableDeleteTooltip(user),
            },
            {
              hidden: !user.isExternalUser,
              label: 'Update Info from PestPac',
              onClick: () => handleUpdateFromPPRequest(user.externalUserId),
            },
          ]}
        />
      )}
    </>
  )
}
